<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!finanziamentoInCorso"
  [dismissableMask]="!finanziamentoInCorso"
  [style]="{width: '55vw'}"
  styleClass="p-fluid conferma-finanziamento-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <span class="material-icons" style="font-size: 28px; margin-right: 8px;">shopping_cart_checkout</span>
        <h2>Conferma Finanziamento della richiesta {{richiesta?.anno}}</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="finanziamentoInCorso"
        (click)="hide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content" *ngIf="richiesta">
      <div class="warning-message">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
        <div class="warning-content">
          <h3>Attenzione</h3>
          <p>Stai per confermare il finanziamento completo della richiesta e di tutti gli interventi rimodulati dall'ente esecutore.</p>
          <p>Questa operazione:</p>
          <ul>
            <li>Confermerà il finanziamento della richiesta</li>
            <li>Confermerà il finanziamento di tutti gli interventi rimodulati</li>
            <li>Non potrà essere annullata</li>
          </ul>
        </div>
      </div>

      <div class="richiesta-info">
        <p-divider></p-divider>
        <div class="info-row">
          <div class="info-label">Ente:</div>
          <div class="info-value">
            <span class="material-symbols-outlined"
              [style.color]="stiliService.getColoreIconaEnteEsecutore(richiesta.enteEsecutore)"
              style="vertical-align: middle; margin-right: 8px;">
              {{ stiliService.getMaterialIconEnteEsecutore(richiesta.enteEsecutore) }}
            </span>
            {{ richiesta.enteEsecutore.label }}
          </div>
        </div>

        <div class="info-row">
          <div class="info-label">Anno:</div>
          <div class="info-value">{{ richiesta.anno }}</div>
        </div>

        <div class="info-row">
          <div class="info-label">Importo richiesto:</div>
          <div class="info-value importo">{{ richiesta.importoRichiesto | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>

        <div class="info-row">
          <div class="info-label">Importo contributo:</div>
          <div class="info-value importo">{{ richiesta.importoContributo | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>
        <div class="info-row">
          <div class="info-label">Importo rimodulato:</div>
          <div class="info-value importo">{{ richiesta.importoRimodulato | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>
      </div>
    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        [disabled]="finanziamentoInCorso"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-success"
        [loading]="finanziamentoInCorso"
        (click)="confermaFinanziamento()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
